import { Component, HostListener, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartConfiguration, ChartConfigurationCustomTypesPerDataset } from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-single-bar-chart',
  standalone: true,
  imports: [],
  template: '',
})
export class BarChartBaseComponent {
  public chart: any;

  // https://github.com/chartjs/Chart.js/issues/7738
  // @HostListener('document:touchend', ['$event.target'])
  // @HostListener('document:click', ['$event.target'])
  // hideTooltip(target: HTMLElement): void {
  //   console.log('chris hideTooltip', this.chart, target.tagName.toLowerCase());

  //   // this.chart.tooltip.opacity = 0;
  //   this.chart.tooltip?.setActiveElements([], { x: 0, y: 0 });
  //   // this.chart.update();
  // }

  // @HostListener('document:click', ['$event.target'])
  // hideTooltip(target: HTMLElement): void {
  //   console.log('################# hideTooltip', this.chart, target.tagName.toLowerCase());

  //   // this.chart.tooltip.opacity = 0;
  //   this.chart.tooltip?.setActiveElements([], { x: 0, y: 0 });
  //   // this.chart.update();
  // }

  // @HostListener('window:beforeprint', ['$event'])
  // onBeforePrint(event: any) {
  //   console.log('Before print', event);
  //   this.chart.resize();
  // }

  // mouseOut(event: any) {
  //   console.log('chris mouseout', event);

  //   this.chart.tooltip?.setActiveElements([], { x: 0, y: 0 });
  // }
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);

  navigateToAssessment(assessmentType: string, documentId: string) {
    console.log('navigateToAssessment', { assessmentType, documentId });
    this.router.navigate(['../../assessments/' + assessmentType.toLowerCase() + '/' + documentId], {
      relativeTo: this.route,
    });
  }
  // updateTooltipShow = (chart: any, enabled: boolean) => {
  //   chart.options.plugins.tooltip.enabled = enabled;
  //   chart.update();
  // };

  getChartConfig(
    datasets: any,
    minDate: any,
    maxDate: any,
    labelDataFull: any,
    reverse: boolean,
    max?: number
  ): ChartConfiguration | ChartConfigurationCustomTypesPerDataset {
    return {
      type: 'bar',
      data: {
        labels: labelDataFull,
        datasets: datasets,
      },
      options: {
        responsive: true,
        aspectRatio: 3,
        animation: {
          // duration: 0,
          delay: 100,
        },
        layout: {
          autoPadding: true,
          //   padding: {
          //     left: 80,
          //     right: 30,
          //   },
        },
        scales: {
          y: {
            min: 0,
            max: max,
            beginAtZero: true,
            reverse: reverse,
            position: 'right',
            grid: {
              display: false,
            },
          },
          x: {
            // beginAtZero: true,
            grid: {
              display: true,
            },
            type: 'time',
            // time: {
            //   tooltipFormat: 'DD.MM.YY',
            //   unit: 'day',
            // },
            min: minDate,
            max: maxDate,
            time: {
              unit: 'week',
              isoWeekday: true,
              displayFormats: {
                week: 'dd, DD.MM.YY',
              },
            },
          },
        },
        // interaction: {
        //   mode: 'index',
        //   intersect: false,
        // },
        // events: ['mousemove', 'click', 'touchstart', 'touchmove', 'mouseout'],
        // alternative: click on bar!
        // https://stackoverflow.com/questions/37122484/chart-js-bar-chart-click-events
        // events: ['mousemove', 'click', 'touchstart', 'touchmove'],
        // onHover: (ee, activeElements, chart) => {
        //   const { bottom, top, right, left } = chart.chartArea;
        //   const e = ee as { x: number; y: number };
        //   if (e !== null && e !== undefined && e.x >= left && e.x <= right && e.y <= bottom && e.y >= top) {
        //     this.updateTooltipShow(chart, true);
        //   } else {
        //     this.updateTooltipShow(chart, false);
        //   }
        // },
        plugins: {
          title: {
            display: false,
            // text: 'Chart.js Line Chart - External Tooltips',
          },
          // tooltip: {
          //   enabled: false,
          //   position: 'average',
          //   external: context => {
          //     externalTooltipHandler(context, this.navigateToAssessment, this);
          //   },
          // },
          tooltip: {
            callbacks: {
              label: function (context) {
                // let label = context.dataset.label || '';
                // console.log('context', context);
                const raw = context.raw as any;
                const yAxisKey = (context.dataset.parsing as any).yAxisKey;
                if (yAxisKey === 'dataL') {
                  return raw.tooltipLabelL;
                } else if (yAxisKey === 'dataR') {
                  return raw.tooltipLabelR;
                } else {
                  return raw.tooltipLabel;
                }

                // if (label) {
                //   label += ': ';
                // }
                // if (context.parsed.y !== null) {
                //   label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                //     context.parsed.y
                //   );
                // }
              },
            },
          },
          legend: {
            position: 'top',
          },
          datalabels: {
            color: 'black',
            display: function (context) {
              // return context.dataset.data[context.dataIndex] > 15;
              return true;
            },
            font: {
              // weight: 'bold',
              size: 10,
            },
            // formatter: Math.round,
            formatter: (val, context) => {
              const parsing = context?.dataset?.parsing as any;
              const key = parsing.yAxisKey;
              //   // console.log('val ', { val, context });
              //   console.log(
              //     'key ' +
              //       key +
              //       ' backgroundColor: "' +
              //       context.dataset.backgroundColor +
              //       '", borderColor: "' +
              //       context.dataset.borderColor +
              //       '"',
              //     { val, context }
              //   );
              return val[key];
            },
          },
        },
      },
      plugins: [this.customCanvasBackgroundColor, ChartDataLabels],
    };
  }

  drawChartBackground(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(0.04, 'rgba(255,255,255,1)');

    gradientBack.addColorStop(0.04, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.25, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.25, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.49, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.49, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.95, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.95, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(1, 'rgba(251,221,221,1)');
  }

  drawChartBackgroundReverse(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(0.2, 'rgba(251,221,221,1)');

    gradientBack.addColorStop(0.2, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.4, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.4, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.6, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.6, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.8, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.8, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(1, 'rgba(255,255,255,1)');
  }

  customCanvasBackgroundColor = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart: any, args: any, options: any) => {
      const {
        ctx,
        chartArea: { left, right, top, bottom, width, height },
      } = chart;
      const canvas = chart.canvas;
      const chartArea = chart.chartArea;

      ctx.save();
      // Chart background
      const gradientBack = canvas.getContext('2d').createLinearGradient(right, bottom, right, top);
      this.drawChartBackground(gradientBack);
      // this.drawChartBackgroundReverse(gradientBack);
      ctx.fillStyle = gradientBack;
      ctx.fillRect(
        chartArea.left,
        chartArea.bottom,
        chartArea.right - chartArea.left,
        chartArea.top - chartArea.bottom
      );
    },
  };
}
